const ACHIEVEMENT_DATA = {
  // ForeverDefense: {
  //   id: '51d62f18-df04-49ac-b89e-cf41183039a9',
  //   title: 'Forever Defense',
  //   desc: 'Destroy (X) barriers',
  //   notes: 'Cross Session',
  //   required: 500,
  //   progress: 0,
  //   completed: false,
  //   hardCodeRequired: null
  // },
  ForeverDefense: {
    id: '51d62f18-df04-49ac-b89e-cf41183039a9',
    title: 'Forever Defense',
    desc: 'Complete 1000 waves',
    notes: 'Cross Session',
    required: 1000,
    progress: 0,
    completed: false,
    hardCodeRequired: null
  },
  HotStuff: {
    id: '4f3e6217-638e-4895-8e55-ea56d6c1e901',
    title: 'Hot Stuff',
    desc: 'Destroy (X) barriers in a row without missing',
    notes: 'Single Session',
    required: 1,
    progress: 0,
    completed: false,
    hardCodeRequired: 50
  },
  CrystalClear: {
    id: 'e39294d3-a2d7-4d8b-8969-9276e8d3cd23',
    title: 'Crystal Clear',
    desc: 'Complete any 5 floors perfectly in a single game',
    notes: 'Single Session',
    required: 1,
    progress: 0,
    completed: false,
    hardCodeRequired: 5
  },
  CannonboltPower: {
    id: '8ca435c3-1d65-4924-9e7d-e90f4e748bc6',
    title: 'Cannonbolt Power',
    desc: 'Earn the Cannonbolt power-up',
    notes: 'Single Session',
    required: 1,
    progress: 0,
    completed: false,
    hardCodeRequired: null
  },
  RockinIt: {
    id: '51a7c178-ef20-4477-a781-1bd491713948',
    title: 'Rockin’ It',
    desc: 'Complete 10 floors in a single game',
    notes: 'Single Session',
    required: 1,
    progress: 0,
    completed: false,
    hardCodeRequired: 10
  }
};

export default ACHIEVEMENT_DATA;
